import React, {useState, useEffect, Fragment} from "react";
import { Link, useNavigate } from 'react-router-dom'
import { athletDashboardURL, dashboardApproveUrl, facultyPosURL, paymentAssoPending, paymentAssoPendingDet, permissionDashboardURL } from "../../apis/urls";
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 
import { Loader, Placeholder } from 'rsuite';
import LoaderDashboard from "../../common-components/dashboardLoader";

const DashBoardContents = () => {




    useEffect( ()=> {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
		$('html,body').animate({ scrollTop: 0 }, 'fast');
        ApproveListing();
		AthletDashboardListing();
		FacultyDashboardListing();
		// PermissionDashboardListing();
		// assoPaymentPending();
		offPaymentPending();
    },[])

    let navigate = useNavigate()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)


	const [giaaloader, setGiaaLoader] = useState(true)
	const [athletloader, setAthleticLoader] = useState(true)
	const [facultyloader, setFacultyLoader] = useState(true)
	const [permissionloader, setPermissionLoader] = useState(true)
	const [assoPendingLoader, setAssoPendingLeader] = useState(true)
	const [offPendingLoader, setOffPendingLeader] = useState(true)


    const [resultGiaa, setresultGiaa] = useState([]);   
	const [giaaLength, setgiaaLength] = useState('');   

	const [resultAthlet, setresultAthlet] = useState([]);   
	const [athletLength, setAthletLength] = useState(''); 

	const [resultFaculty, setResultFaculty] = useState([]);   
	const [resultFaculty1, setResultFaculty1] = useState([]);   
	const [facultyLength, setFacultyLength] = useState(''); 

	const [resultPermission, setResultPermission] = useState([]);   
	const [permissionLength, setPermissionLength] = useState(''); 

	const [paymentPending, setPaymentPending] = useState([]);   
	const [paymentPendingLength, setPaymentPendingLength] = useState(''); 

	const [paymentOfficials, setPaymentOfficials] = useState([]);   
	const [paymentOfficialsLength, setPaymentOfficialsLength] = useState(''); 


    let token = "Bearer "+localStorage.getItem('token');

    const ApproveListing = () => {
         
        const instance = axios.create({

            baseURL: dashboardApproveUrl,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            setresultGiaa(response.data.data);
			setgiaaLength(response.data.data.length);
			setGiaaLoader(false)            

          }).catch((error) =>{
            

            console.log('error',error.message)
            
          });

    }


	const AthletDashboardListing = () => {
         
        const instance = axios.create({

            baseURL: athletDashboardURL,

            timeout: 1000000,

            headers: {'authorization': token},

          });
          
          instance.get('',).then((response) =>{
            
            setresultAthlet(response.data.data);
			setAthletLength(response.data.data.length);
			setAthleticLoader(false)

          }).catch((error) =>{
            
            localStorage.removeItem('token')
    
            navigate("/")

            console.log('error',error.message)
            
          });

    }


	const FacultyDashboardListing = () => {
         
        const instance = axios.create({

            baseURL: facultyPosURL,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResultFaculty(response.data.data);
			setFacultyLength(response.data.data.length);
			setFacultyLoader(false)
			// console.log("== >", response.data)


          }).catch((error) =>{
            
            // localStorage.removeItem('token')
    
            // navigate("/")

            console.log('error',error.message)
            
          });

    }


	// const PermissionDashboardListing = () => {
         
    //     const instance = axios.create({

    //         baseURL: permissionDashboardURL,

    //         timeout: 1000000,

    //         headers: {'authorization': token}

    //       });
          
    //       instance.get('').then((response) =>{
            
    //         setResultPermission(response.data.data);
	// 		setPermissionLength(response.data.data.length);
	// 		setPermissionLoader(false)
	// 		// console.log("== >", response.data.data.length)

    //       }).catch((error) =>{
            
    //         // localStorage.removeItem('token')
    
    //         // navigate("/")

    //         console.log('error',error.message)
            
    //       });

    // }



	// const assoPaymentPending = () => {
         
    //     const instance = axios.create({

    //         baseURL: paymentAssoPending,

    //         timeout: 1000000,

    //         headers: {'authorization': token}

    //       });
          
    //       instance.get('').then((response) =>{
	// 		setPaymentPending(response.data.data)
	// 		setPaymentPendingLength(response.data.data.length)
	// 		setAssoPendingLeader(false)            

    //       }).catch((error) =>{
            

    //         console.log('error',error.message)
            
    //       });

    // }




	const offPaymentPending = () => {
         
        const instance = axios.create({

            baseURL: paymentAssoPendingDet,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
			setPaymentOfficials(response.data.data)
			setPaymentOfficialsLength(response.data.data.length)
			setOffPendingLeader(false)            

			// console.log("datasssssssssss =========================>", response.data.data)

          }).catch((error) =>{
            

            console.log('error',error.message)
            
          });

    }


    let sl=1;
	let arr=0;

	let newarr=0;
	let uparr=0;
	let inarr=0;
	let apparr=0;


    return( 
        <div className="dashboard">
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div>

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Dashboard</h2>
                        </div>
                    </div>


				<div class="dashboard-wrpr row">


				{!giaaloader?
					<div class="col-md-5">
						<div class="card dash-card one" style={{height:'350px'}}>
							<div class="card-header">
								Pending by GIAA
							</div>
							<div class="card-body">
								<table class="table table-rules">
									<thead>
										<tr class="rules-table-head">
											<th>School</th>
											<th>Pending by GIAA </th>
										</tr>
										
									</thead>
									<tbody class="rules-table-content">
									{resultGiaa?
											<Fragment>
											{
												resultGiaa.slice(0, 4)?.map((item,index) =>(
										<tr >
											<td>{decode(item.schoolName)}</td>
											<td><Link  to={"/giaa_dashboard/"+arr++} style={{color:'white'}} data-toggle="tooltip" title="Athletic Eligibility">{item.count}</Link></td>
										</tr>
											))
										}
										</Fragment>:null	
									}
									</tbody>
									
								</table>
							</div>


							<div class="card-footer text-right">
							{giaaLength === 0 ?
								<h3 style={{textAlign:'center',paddingBottom:'25%', color:'#fff'}}>Pending not found

								</h3>:
								<div class="card-footer text-right">
									<Link class="item-link btn btn-default btn-sml item-readmore" to="/dashboard_giaa">Read More</Link>
								</div>
							}
							</div>
						</div>
						
					</div>:

					<div class="col-md-5">
						<div class="card dash-card one" style={{height:'350px'}}>
							<div class="card-header">
									Pending by GIAA
							</div>
							<div class="card-body">
								
							</div>

							<div class="card-footer text-right">
								<div style={{textAlign:'center',paddingBottom:'30%', color:'#fff'}}>
									<LoaderDashboard />
								</div>
							</div>
						</div>
						
					</div>
					}
					
					{!athletloader?
					<div class="col-md-7">
						<div class="card dash-card two"  style={{height:'350px'}}>
							<div class="card-header">
								Athletic Eligibility (Last 7 Days)
							</div>
							<div class="card-body">
								<table class="table table-rules">
									<thead>
										<tr class="rules-table-head">
											<th>School</th>
											<th>New AE</th>
											<th>Updated AE</th>
											<th>Ineligible by HO</th>
											<th>Approved by GIAA</th>
										</tr>
										
									</thead>
									<tbody class="rules-table-content">
										{resultAthlet?
											<Fragment>
											{
												resultAthlet.slice(0, 4)?.map((item,index) =>(
												<tr>
													<td>{decode(item.schoolname)}</td>
													<td>
														<Link  to={"/new_athletic_dashboard/"+newarr++} style={{color:'white'}} data-toggle="tooltip" title="New Athletic Eligibility">
															{item.createdCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.createdCount}
														</Link>
													</td>
													<td>
														<Link  to={"/updated_athletic_dashboard/"+uparr++} style={{color:'white'}} data-toggle="tooltip" title="Updated Athletic Eligibility">
															{item.updatedCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.updatedCount}
														</Link>
													</td>

													<td>
														<Link  to={"/ineligible_athletic_dashboard/"+inarr++} style={{color:'white'}} data-toggle="tooltip" title="Ineligible Athletic Eligibility">
															{item.inligibleCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.inligibleCount}
															
														</Link>
													</td>



													<td>
														<Link  to={"/approved_athletic_dashboard/"+apparr++} style={{color:'white'}} data-toggle="tooltip" title="Approved Athletic Eligibility">
															{item.gisaApprovedCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.gisaApprovedCount}
														</Link>
													</td>
												</tr>
												))
											}
											</Fragment>:null	
										}
									</tbody>									
								</table>
							</div>
							{athletLength === 0 ?
								<h3  style={{textAlign:'center',paddingBottom:'25%', color:'#fff'}}>Athletic Eligibility not found</h3>:
								<div class="card-footer text-right">
									<Link class="item-link btn btn-default btn-sml item-readmore" to="/dashboard_athletic">Read More</Link>
								</div>
							}
						</div>
						
					</div>:
					<div class="col-md-7">
						<div class="card dash-card two" style={{height:'350px'}}>
							<div class="card-header">
								Athletic Eligibility (Last 7 Days)
							</div>
							<div class="card-body">
								
							</div>

							<div class="card-footer text-right">
								<div style={{textAlign:'center',paddingBottom:'20%', color:'#fff'}}>
									<LoaderDashboard />
								</div>
							</div>
						</div>
						
					</div>
					}

					
					
					{!facultyloader?
					<div class="col-md-7">
						<div class="card dash-card three">
							<div class="card-header">
								Admin/Staff (Last 7 Days)
							</div>
							<div class="card-body">
								<table class="table table-rules">
									<thead>
										<tr class="rules-table-head">
											<th>School</th>
											<th>Faculty Name</th>
											<th>Position</th>
										</tr>
										
									</thead>
									<tbody class="rules-table-content">
									 {resultFaculty?
										<Fragment>
											{
												resultFaculty.slice(0, 4)?.map((item,index) =>(
												<Fragment>
													<tr key={index}>
													<td>{decode(item.schoolname)}</td>
													<td>{item.facultyName}</td>
													<td style={{textAlign:'justify'}}>{item.positions}</td>
												</tr>
												</Fragment>
												))
											}
										</Fragment>:null
									}												

									</tbody>
									
								</table>
							</div>
							<div class="card-footer text-right">
							{facultyLength === 0 ?
								<h3 style={{textAlign:'center',padding:'20%', color:'#fff'}}>Admin/Staff not found</h3>:
								<Link class="item-link btn btn-default btn-sml item-readmore" to="/dashboard_faculty">Read More</Link>
							}
							</div>
						</div>
						
					</div>:

					<div class="col-md-6">
						<div class="card dash-card three">
							<div class="card-header">
								Admin/Staff (Last 7 Days)

							</div>
							<div class="card-body">
								
							</div>

							<div class="card-footer text-right">
								<div style={{textAlign:'center', color:'#fff'}}>
									<LoaderDashboard />
								</div>
							</div>
						</div>
						
					</div>
					}
					
					
					
					{/* {!permissionloader?
					<div class="col-md-4">
						<div class="card dash-card four">
							<div class="card-header">
								Permission
							</div>
							<div class="card-body">
								<table class="table table-rules">
									<thead>
										<tr class="rules-table-head">
											<th>School</th>
											<th>Permission Count</th>
										</tr>
										
									</thead>
									<tbody class="rules-table-content">
									{resultAthlet?
											<Fragment>
											{
												resultPermission.slice(0, 4)?.map((item,index) =>(
												<tr>
													<td>{decode(item.schoolname)}</td>
													<td><Link  to={"/members/"+item.schoolsid} style={{color:'white'}} data-toggle="tooltip" title="Permission">{item.permissionCount}</Link></td>
												</tr>
												))
											}
											</Fragment>:null	
										}
									</tbody>
									
								</table>
							</div>
								<div class="card-footer text-right">
									{permissionLength === 0 ?
										<h3 style={{textAlign:'center',padding:'20%', color:'#fff'}}>Permission not found</h3>:
										<Link class="item-link btn btn-default btn-sml item-readmore" to="/dashboard_permission">Read More</Link>
									}								
								</div>
						</div>
						
					</div>:



					<div class="col-md-6">
						<div class="card dash-card three">
							<div class="card-header">
							Permission

							</div>
							<div class="card-body">
								
							</div>

							<div class="card-footer text-right">
								<div style={{textAlign:'center', color:'#fff'}}>
									<LoaderDashboard />
								</div>
							</div>
						</div>
						
					</div>
					} */}



				{!offPendingLoader?
					<div class="col-md-5">
						<div class="card dash-card two"  style={{height:'350px'}}>
							<div class="card-header">
								Officials (Last 7 Days)
							</div>
							<div class="card-body">
								<table class="table table-rules">
									<thead>
										<tr class="rules-table-head">
											<th>Association Name</th>
											<th>New Officials</th>
											{/* <th>Payment Pending</th> */}
											<th>Check Pending</th>
										</tr>
										
									</thead>
									<tbody class="rules-table-content">
										{paymentOfficials?
											<Fragment>
											{
												paymentOfficials.slice(0, 4)?.map((item,index) =>(
												<tr>
													<td>{decode(item.asso_name)}</td>
								
													<td>
														<Link  to={"/new_officials/"+item.asso_id} style={{color:'white'}} data-toggle="tooltip" title="New Officials">
															{item.createdCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.createdCount}
														</Link>
													</td>
													{/* <td>
														<Link  to={"/updated_athletic_dashboard/"+uparr++} style={{color:'white'}} data-toggle="tooltip" title="Updated Athletic Eligibility" disabled>
															{item.updatedCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.paymentPending}
														</Link>
													</td> */}

													<td>
														<Link  to={"/official/pending/"+item.asso_name+"/"+item.asso_id} style={{color:'white'}} data-toggle="tooltip" title="Check payment pendings">
															{item.checkPending=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.checkPending}
														</Link>
													</td>
												</tr>
												))
											}
											</Fragment>:null	
										}
									</tbody>									
								</table>
							</div>
							{paymentOfficialsLength === 0 ?
								<h3  style={{textAlign:'center',paddingBottom:'25%', color:'#fff'}}>Officials not found</h3>:
								<div class="card-footer text-right">
									<Link class="item-link btn btn-default btn-sml item-readmore" to="/dashboard/associations">Read More</Link>
								</div>
							}
						</div>
						
					</div>:
					<div class="col-md-8">
						<div class="card dash-card two" style={{height:'350px'}}>
							<div class="card-header">
								Officials (Last 7 Days)
							</div>
							<div class="card-body">
								
							</div>

							<div class="card-footer text-right">
								<div style={{textAlign:'center',paddingBottom:'20%', color:'#fff'}}>
									<LoaderDashboard />
								</div>
							</div>
						</div>
						
					</div>
					}







					
				</div>

				

                    </div>
                </div>
            </aside>
        </div>
    )
};

export default DashBoardContents;
